import Highcharts from 'highcharts'
import axios from 'axios';


const $trands = document.querySelector('.n-about__trands-items')

if ($trands) {
    trandsHandler()
}

function trandsHandler() {
    const $chartBtc = document.querySelector('[data-trend-main-btc]')
    const $chartEth = document.querySelector('[data-trend-main-eth]')
    const $chartBnb = document.querySelector('[data-trend-main-bnb]')
    const $chartXrp = document.querySelector('[data-trend-main-xrp]')

    const klinesBtc = axios.get(`https://api.binance.com/api/v3/klines?symbol=BTCUSDT&interval=15m&limit=96`);
    const klinesEth = axios.get(`https://api.binance.com/api/v3/klines?symbol=ETHUSDT&interval=15m&limit=96`);
    const klinesBnb = axios.get(`https://api.binance.com/api/v3/klines?symbol=BNBUSDT&interval=15m&limit=96`);
    const klinesXrp = axios.get(`https://api.binance.com/api/v3/klines?symbol=XRPUSDT&interval=15m&limit=96`);

    klinesBtc.then((response) => {
        createChart($chartBtc, response.data,2)
    })
    klinesEth.then((response) => {
        createChart($chartEth, response.data,2)
    })
    klinesBnb.then((response) => {
        createChart($chartBnb, response.data,2)
    })
    klinesXrp.then((response) => {
        createChart($chartXrp, response.data,4)
    })

    function createDataset(klines) {

        return klines.map((kandle) => {
            const low = parseFloat(kandle[3])

            const high = parseFloat(kandle[2])

            return parseFloat((low + ((high - low) / 2)).toFixed(6))
        })
    }

    // closePrice последней правой свечи — openPrice первой левой свечи = priceChange  это абсолютное значение
    // priceChange * 100 / openPrice первой левой свечи = priceChangePercent это в %

    function createChart($wrapper, klines,fixed) {
        const changeClassMinus = 'n-about__trands-item-info-numbers-change--minus'
        const changeClassPlus = 'n-about__trands-item-info-numbers-change--plus'
        const colorPlus = '#FE6703'
        const colorMinus = '#0038FF'

        const dataset = createDataset(klines);

        const $chart = $wrapper.querySelector('.n-about__trands-item-info-chart')
        const $price = $wrapper.querySelector('.n-about__trands-item-info-numbers-main')
        const $change = $wrapper.querySelector('.n-about__trands-item-info-numbers-change')


        const current = dataset[dataset.length - 1]
        const prev = dataset[0]

        let color;
        let changeAbsolut = klines[klines.length - 1][4] - klines[0][2];
        let change = changeAbsolut * 100 / klines[0][2];

        let changeText;

        if (change > 0) {
            changeText = `+$${changeAbsolut.toFixed(fixed)} (${change.toFixed(fixed)}%)`
        } else {
            changeText = `-$${(changeAbsolut * -1).toFixed(fixed)} (${change.toFixed(fixed)}%)`
        }

        $change.innerText = changeText

        if (prev > current) {
            color = colorMinus
            $change.classList.add(changeClassMinus)
        } else {
            color = colorPlus
            $change.classList.add(changeClassPlus)
        }

        $price.innerText = `$${current.toLocaleString()}`


        Highcharts.chart($chart, {
            title: null, subtitle: null, tooltip: false, legend: false, xAxis: {
                title: {text: undefined},
                labels: {enabled: false},
                tickPosition: 'inside',
                crosshair: false,
                tickInterval: 1,
                type: 'logarithmic',
            }, yAxis: {
                title: {text: undefined},
                labels: {enabled: false},
                tickPosition: 'inside',
                crosshair: false,
                type: 'logarithmic',
                minorTickInterval: 0.1,
            }, series: [{
                data: dataset, pointStart: 1, color
            }]
        });
    }
}


